<template>
    <span>
      <span class="starNo">{{ number }}</span>
      <b-icon
        v-if="star"
        icon="star-fill"
        style="color:gold"
        font-scale="2"
      />
      <b-icon
        v-if="plus"
        icon="plus"
        font-scale="1.8"
      />
    </span>
  </template>
  
  <script>
  export default {
    props: {
      classification: String
    },
    data() {
      return {
        number: '',
        star: false,
        plus: false
      };
    },
    created() {
      this.displayRating()
    },
    methods: {
      displayRating() {
        if(this.classification) {
          // expected format: 5 star plus
          this.number = this.classification.charAt(0)
          let text = this.classification.substring(1)
          if (text.indexOf('star') >-1) {
            this.star = true
          }
          if (text.indexOf('plus') >-1) {
            this.plus = true
          }
        }
      }
    }
  };
  </script>
  <style scoped>
  .starNo {
    font-size: 1.8rem;
    padding-right: 2px;
  }
  </style>
  